import { Link } from "react-router-dom"
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NoRole() {
const navigate = useNavigate();

const handleLogout = () => {
    
    localStorage.removeItem("ROLE");
    localStorage.removeItem("username");
    localStorage.removeItem("Auth");
    localStorage.removeItem("email");
    localStorage.removeItem("teamcode");
    localStorage.removeItem("Token")
    navigate("/login");
    };
    return (
        <article style={{ padding: "100px" }}>
            <h1>Oops!</h1>
            <p>You cant able to access the tool because you dont have any role assigned please login once admin provides you the role!!!</p>
            <div className="flexGrow">
                <Button onClick={handleLogout}>Visit Our Login Page</Button>
            </div>
        </article>
    )
}

